// ====================================================================
// 2) src/hooks/usePostAuthNotice.js
// ====================================================================
import { useEffect, useState } from "react";

export function usePostAuthNotice() {
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("post_auth_notice");
      if (!raw) return;
      const parsed = JSON.parse(raw);
      // Only accept recent notices (e.g., 5 minutes)
      const fresh = parsed?.ts && Date.now() - parsed.ts < 5 * 60 * 1000;
      if (fresh) setNotice(parsed);
      sessionStorage.removeItem("post_auth_notice"); // one-time
    } catch {
      // ignore
    }
  }, []);

  const clear = () => setNotice(null);
  return { notice, clear };
}
